import { css } from 'styled-components';

// An inline <svg> sits on the text baseline and reserves descender space below
// itself, so its box is taller than the icon; block takes it out of that flow.
export const sizedIcon = css`
  display: block;
  flex-shrink: 0;
`;
